<template>
  <div class="withdraw-record">
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 提现时间 -->
      <el-date-picker
        v-model="search.times"
        size="small"
        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!--交易状态  -->
      <el-select v-model="search.disburse_status" size="small" class="search-frame status mb-10" :placeholder="$t('merchantAccount.po_trans_status')" clearable>
        <el-option
          v-for="(item,index) in withdrawTransactionStatusMap"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- 查询 -->
      <el-button class="search-btn mb-10" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <!-- <el-button size="small" class="mb-24 download-btn" type="info" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button> -->
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('data.currency')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.currency }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ compAmount(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account_name }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dashboard.fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.operator')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_user && scope.row.merchant_user.username }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tag :type="getWithdrawTransStyle(scope.row.disburse_status)">{{ getWithdrawTransStatusLabel(scope.row.disburse_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.note')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchMchWithdrawInfo, fetchMchWithdrawInfoAllList } from '@/api/settlement/settlement'
import { withdrawTransactionStatusMap } from '@/utils/maps'
import { exportXlsx, filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Withdraw_Record',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        disburse_status: null, // 交易状态
        times: [appointDate(-3), appointDate()],
        blank: ''
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    compAmount() {
      return function(row) {
        const toDivideWithDot = this.$options.filters['toDivideWithDot']
        if (row.currency !== 'PHP' && row.mch_withdraw_info) {
          return toDivideWithDot(row.mch_withdraw_info.amount)
        }

        return toDivideWithDot(row.amount)
      }
    },
    withdrawTransactionStatusMap() {
      return withdrawTransactionStatusMap()
    },
    getWithdrawTransStatusLabel() {
      return function(value) {
        return withdrawTransactionStatusMap(value).label
      }
    },
    getWithdrawTransStyle() {
      return function(value) {
        return withdrawTransactionStatusMap(value).type
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getMchWithdrawInfo(params) {
      this.listLoading = true
      fetchMchWithdrawInfo(params).then(res => {
        if (res.code === 10000) {
          if (!res.data) {
            return
          }
          const { total = 0, list = [] } = res.data || {}
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { disburse_status, times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], disburse_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getMchWithdrawInfo(params)
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 90)) {
        this.$message.warning('The maximum date range  is limited to 90 days, please select again')
        return
      }
      this.downloading = true
      fetchMchWithdrawInfoAllList(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Start downloading!')
          this.handleXlsxData(res.data).then((downloadData) => {
            exportXlsx(downloadData, 'Withdraw_Record')
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('data.currency'),
        this.$t('merchantAccount.amount'),
        this.$t('merchantAccount.bank'),
        this.$t('merchantAccount.bank_account'),
        this.$t('merchantAccount.bank_account_name'),
        this.$t('dashboard.fee'),
        this.$t('merchantAccount.operator'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time'),
        this.$t('merchantAccount.note')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.currency,
            toDivide100(tr.currency !== 'PHP' ? (tr.mch_withdraw_info && tr.mch_withdraw_info.amount) : tr.amount),
            tr.bank,
            tr.bank_account,
            tr.bank_account_name,
            toDivide100(tr.fee_split),
            tr.merchant_user && tr.merchant_user.username,
            this.getWithdrawTransStatusLabel(tr.disburse_status),
            tr.create_time,
            tr.transaction_return_time,
            tr.remark
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw-record{
  background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
